<template>
  <section id="vote_card_demo_page">

    <h3 class="section_title">Voting</h3>

    <!-- IF VOTE PAGE SHOULD NOT SHOW, DISPLAY TIMER -->
    <div class="vote_page_inactive"
    v-if="!voting_period_started"
    >
      <!-- COUNTDOWN -->
      <countdown
      target_date="12/05/2018 12:00 AM UTC-0400"
      title="Voting starts in:"
      ></countdown>

      <!-- NEED TO MAKE THIS TEXT DYNAMIC FROM DATABASE??? -->
      <div class="container">

        <div class="row">
          <div class="col-12">
            <large-centered-button
            button_text="Nominate Now"
            icon="clipboard-check"
            width="full"
            @button_clicked="goto_path('nominate')"
            ></large-centered-button>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            
            <p>
              We're just as excited as you are for voting to begin!
            </p>

            <p
            v-if="nomination_period_started"
            >
              But just because voting hasn't started yet doesn't mean there's nothing to do. Head on over to our <a href="/nominate" @click="goto_path('nominate')">nominations section</a> and tell us who you'd like to see in the final contests.
            </p>

            <p>
              If you've already nominated all your favorites, check out some other great content from Dayton.com below.
            </p>

            <story-list
            cms_list_id='69728dd0-6965-11e6-ab50-bec7bcde827e'
            ></story-list>

          </div>
        </div>
      </div>
      

    </div>

    <!-- IF VOTE PAGE SHOULD SHOW, SHOW IT -->
    <div class="vote_page_active"
    v-if="voting_period_started"
    >
      
      <trans-zoom>

        <!-- LOGIN PROMPT FOR NON-LOGGED-IN USERS -->
        <login-prompt
        v-if="!is_logged_in"
        ></login-prompt>

        <!-- VOTE CARD CONTAINER FOR LOGGED-IN USERS ONLY -->
        <div class="vote_card_outer_container"
        v-if="is_logged_in"
        >

          <trans-bounce>

            <!-- VOTE CARD "A" -->
            <vote-card
            :contest="contest_list[0]"
            :contestants="contestant_list"
            :vote_complete="vote_complete"
            :sponsors="sponsors"
            @contest_vote_submitted="record_vote"
            @next_contest_requested="change_vote_card"
            v-if="show_contest_index == 0"
            key="vote_card_a"
            ></vote-card>

            <!-- VOTE CARD "B" -->
            <vote-card
            :contest="contest_list[1]"
            :contestants="contestant_list"
            :vote_complete="vote_complete"
            :sponsors="sponsors"
            @contest_vote_submitted="record_vote"
            @next_contest_requested="change_vote_card"
            v-else
            key="vote_card_b"
            ></vote-card>

          </trans-bounce>

        </div>

      </trans-zoom>

    </div>

    <p class="text-center" style="margin: 0">
      <button class="btn btn-secondary" type="button"
      @click="toggle_vote_period_start()"
      >Toggle voting started</button>
    </p>

  </section>
</template>

<script>
import router from '@/router';
import StoryList from '@/components/lists/story_list.vue';
import VoteCard from '@/features/vote/vote_card.vue';
import LoginPrompt from '@/features/login/login_prompt.vue';
import Countdown from '@/features/countdown/countdown_timer.vue';
import contestant_list from '@/json/sample_contestant_list.json';
import TransZoom from '@/components/transitions/trans_zoom.vue';
import TransBounce from '@/components/transitions/trans_bounce_inL_outR.vue';
import LargeCenteredButton from '@/components/buttons/large_centered_button.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
library.add(faSearch);

export default {
  name: 'VoteCardDemoPage',
  data () {
    return {
      contest_list: [],
      contestant_list: contestant_list.contestants,
      sponsors: [
        {
          name: 'Bill\'s Donuts',
          logo_url: 'https://store-ysa7mo.mybigcommerce.com/product_images/logo_thumb.png',
          website_url: 'http://billsdonutshop.com/'
        },
        {
          name: 'Stan the Donut Man',
          logo_url: 'https://scontent.fluk1-1.fna.fbcdn.net/v/t1.0-9/12189751_10153675145671894_1012819119755676509_n.jpg?_nc_cat=107&oh=b3dd5b957f699a1242c150fcccdc2515&oe=5C620EDB',
          website_url: 'https://www.facebook.com/pages/Stan-The-Donut-Man/117942361565254'
        }
      ],
      show_contest_index: 0,
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      nomination_period_started: true
    }
  },
  created() {
    this.contest_list = this.$root.store.contests.get_master_contest_list();
  },
  computed: {
    is_logged_in: function() {
      return this.$root.store.session.check_login_status();
    }
  },
  methods: {
    toggle_vote_period_start: function() {
      this.voting_period_started = !this.voting_period_started;
      window.scrollTo(0,0);
    },
    change_vote_card: function() {
        // UPDATE "VOTE_COMPLETE" TO FALSE TO RESET
        this.vote_complete = false;

        if(this.show_contest_index == 0) {
          this.show_contest_index = 1;
        }
        else {
          this.show_contest_index = 0;
        }

        setTimeout(function() {
          window.scrollTo(0,0);
        }, 1200);
        
    },
    record_vote: function() {
      // CATPURE "THIS"
      let vm = this;
      // UPDATE "VOTE_COMPLETE" TO TRUE
      this.vote_complete = true;

      // ARTIFICIAL DELAY TO SHOW USER THAT VOTE WAS COMPLETE
      setTimeout(function() {
        vm.change_vote_card();
      },1500);
    },
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  metaInfo: {
    title: 'Vote Card Demo Page',
    titleTemplate: '%s | Best of Dayton 2019',
    meta: [
      {
        name: 'description',
        vmid: 'description',
        content: 'Nominate your favorite local businesses, food, service providers, and more!'
      },
      {
        property: 'og:title',
        content: 'Nominate for Best of Dayton 2019'
      },
      {
        property: 'og:site_name',
        content: 'Best of Dayton 2019'
      },
      {
        property: 'og:type',
        content: 'website'
      },
      {
        property: 'og:description',
        content: 'Nominate your favorite local businesses, food, service providers, and more!'
      },
      {
        property: 'og:image',
        content: 'https://www.whio.com/rf/image_inline/Pub/Web/WHIO/Special%20Contents/Imported%20Images/Doppler%20Images/Live%20Doppler%207.jpg'
      }
    ]
  },
  components: {
    VoteCard,
    LoginPrompt,
    TransZoom,
    TransBounce,
    Countdown,
    StoryList,
    LargeCenteredButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/VoteCardDemoPage.vue